var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.014.9a1.125 1.125 0 1 1 1.721 1.45L5.941 9.235a1.128 1.128 0 0 1-.918.4 1.126 1.126 0 0 1-.919-.4L.724 5.22a1.125 1.125 0 0 1 1.722-1.45l2.577 3.063L10.013.9z",
    fill: "currentColor"
  })));
};
export default SvgCheckMark;